import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";


async function getDrivers(page,term = '') {
  const res = await getFetch(`/Driver?${page}&term=${term}`);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function deleteDriver(id) {
  const res = await postFetchWithBody(`/Driver/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeDriver(form) {
  if (form.get("name") === "") {
    return {
      status: "error",
      message: "نام و نام خانوادگی الزامی است!",
    };
  }
  if (form.get("melli_code") === "") {
    return {
      status: "error",
      message: "کدملی الزامی است!",
    };
  }
  if (form.get("cellphone") === "") {
    return {
      status: "error",
      message: "شماره موبایل الزامی است!",
    };
  }

  const res = await postFetchWithToken("/Driver/store", form);
  if (res.status !== "error") {
    return {
      status: "success",
      message: "راننده با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}

export { storeDriver , getDrivers,deleteDriver};
